<template>
  <main class="page-not-found">
    <div
      :style="{
        background: `url('${page404Data.bg_image}') repeat,${$root.color_schema.primary}`,
      }"
    >
      <div
        :class="{
          'container error-wrapper': true,
          'text-white': !getContrastYIQ($root.color_schema.primary),
          'text-gray': getContrastYIQ($root.color_schema.primary),
        }"
      >
        <div class="error-text">
          <h1 class="span-header">{{ page404Data.title }}</h1>
          <h2 class="span-paragraph">{{ page404Data.description }}</h2>
          <div class="button-wrap">
            <a
              :title="$root.i18n.take_me_to_the_homepage"
              :href="page404Data.redirect_url"
              class="back-button"
              >{{ $root.i18n.take_me_to_the_homepage }}</a
            >
          </div>
        </div>
        <div class="error-img" v-if="page404Data.image">
          <img
              v-if="$root.enable_lazyload"
              v-lazy="page404Data.image"
              width="438"
              height="411"
              alt="Error-img"
            />
            <img
              v-else
              :src="page404Data.image"
              width="438"
              height="411"
              alt="Error-img"
            />
        </div>
      </div>
      <div class="container content-wrapper mobile-scroll-container">
        <template v-for="(data, index) in page404DataBlocks">
          <template v-if="
              data.blockName === 'wpvcb/casino-toplist' &&
              data.attrs &&
              data.attrs.style === 'gamepage_top_3' &&
              data.filtered_content &&
              data.filtered_content.length > 0">
            <div class="mobile-container" :key="`${data.blockName}-${index}`">
              <template v-if="!hideToplistLabelGB && gamesTop3.length > 0">
                <div v-for="(val, index) in gamesTop3" :key="index">
                  <span
                    :class="{
                      'span-h2 cut-span custom-font-1': true,
                      'text-white': !getContrastYIQ($root.color_schema.primary),
                      'text-gray': getContrastYIQ($root.color_schema.primary),
                    }"
                    >{{ gamesTop3Title[index] }}</span
                  >
                  <div class="mobile-scroller">
                    <div class="row wd-auto">
                      <div
                        class="col-md-4 col-sm-4 mw-300"
                        v-for="(data, index) in val"
                        :key="index"
                      >
                        <div
                          :class="{
                            'play-card': true,
                            'term-recas':
                              (data.bonus_tc && data.bonus_tc != '') ||
                              (data.terms && data.terms != ''),
                            'top-choice': index === 0,
                            'rm-bottom-color':
                              index === 0 &&
                              ((data.bonus_tc && data.bonus_tc != '') ||
                                (data.terms && data.terms != '')),
                          }"
                        >
                          <div class="play-card-top">
                            <div class="play-card-top-img pos-relative">
                              <a
                                :title="data.product_name"
                                :href="getGoLink(data.go_link, data.slug)"
                                class="partner-logo cas-link"
                                :rel="
                                  $root.change_cta_to_sponsored
                                    ? 'nofollow sponsored'
                                    : 'nofollow'
                                "
                                target="_blank"
                              >
                                <img
                                  v-if="
                                    $root.enable_lazyload &&
                                    assets_images &&
                                    assets_images.pro_asset_sizes
                                  "
                                  v-lazy="
                                    data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          (ele) =>
                                            ele.asset_category_name ===
                                            assets_images.pro_asset_sizes.medium
                                        )[0].url
                                      : ''
                                  "
                                  width="72"
                                  height="72"
                                  :alt="
                                    getAltText(
                                      data.product_name,
                                      data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      ).length > 0
                                        ? data.product_assets.filter(
                                            (ele) =>
                                              ele.asset_category_name ===
                                              assets_images.pro_asset_sizes
                                                .medium
                                          )[0].url
                                        : ''
                                    )
                                  "
                                />
                                <img
                                  v-else-if="
                                    assets_images &&
                                    assets_images.pro_asset_sizes
                                  "
                                  :src="
                                    data.product_assets.filter(
                                      (ele) =>
                                        ele.asset_category_name ===
                                        assets_images.pro_asset_sizes.medium
                                    ).length > 0
                                      ? data.product_assets.filter(
                                          (ele) =>
                                            ele.asset_category_name ===
                                            assets_images.pro_asset_sizes.medium
                                        )[0].url
                                      : $root.site_url +
                                        $root.asset_path +
                                        '/failure.png'
                                  "
                                  width="72"
                                  height="72"
                                  :alt="
                                    getAltText(
                                      data.product_name,
                                      data.product_assets.filter(
                                        (ele) =>
                                          ele.asset_category_name ===
                                          assets_images.pro_asset_sizes.medium
                                      ).length > 0
                                        ? data.product_assets.filter(
                                            (ele) =>
                                              ele.asset_category_name ===
                                              assets_images.pro_asset_sizes
                                                .medium
                                          )[0].url
                                        : $root.site_url +
                                            $root.asset_path +
                                            '/failure.png'
                                    )
                                  "
                                />
                                <div class="partner-hover wd-recm">
                                  <div
                                    class="partner-hover-inner"
                                    :style="{
                                      '--primary-btn':
                                        $root.color_schema.primary_btn,
                                      '--primary-btn-hover': pSBC(
                                        -0.2,
                                        $root.color_schema.primary_btn
                                      ),
                                    }"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="10"
                                      height="16"
                                      viewBox="0 0 10 16"
                                      fill="none"
                                    >
                                      <path
                                        d="M9.44469 7.37568L2.32449 0.255608C2.15981 0.090796 1.93997 0 1.70557 0C1.47116 0 1.25133 0.090796 1.08664 0.255608L0.562291 0.779831C0.22109 1.12142 0.22109 1.6766 0.562291 2.01767L6.5413 7.99668L0.555657 13.9823C0.390975 14.1471 0.300049 14.3668 0.300049 14.6011C0.300049 14.8357 0.390975 15.0554 0.555657 15.2203L1.08001 15.7444C1.24482 15.9092 1.46453 16 1.69893 16C1.93334 16 2.15317 15.9092 2.31785 15.7444L9.44469 8.61782C9.60976 8.45248 9.70043 8.23174 9.69991 7.99707C9.70043 7.7615 9.60976 7.54088 9.44469 7.37568Z"
                                        fill="white"
                                      />
                                    </svg>
                                  </div>
                                </div>
                                <div
                                  :class="{
                                    'stripe text-center': true,
                                    'font-dark': getContrastYIQ(
                                      Object.keys(hasTag(data.tags)).length > 0
                                        ? hasTag(data.tags).color
                                        : null
                                    ),
                                    'font-light': !getContrastYIQ(
                                      Object.keys(hasTag(data.tags)).length > 0
                                        ? hasTag(data.tags).color
                                        : null
                                    ),
                                  }"
                                  v-if="
                                    Object.keys(hasTag(data.tags)).length > 0
                                  "
                                  :style="{
                                    backgroundColor:
                                      Object.keys(hasTag(data.tags)).length > 0
                                        ? hasTag(data.tags).color
                                        : null,
                                  }"
                                >
                                  <img
                                    :src="hasTag(data.tags).icon"
                                    width="18"
                                    height="12"
                                    alt="tag-icons"
                                  />
                                </div>
                              </a>
                            </div>
                            <div
                              class="play-card-top-right gamefree-casino-404"
                            >
                              <span class="span-h5 custom-font-1">
                                <template v-if="hideBonusLabelGB">
                                  <span>{{
                                    $root.i18n.hidden_partner_bonus
                                  }}</span>
                                </template>
                                <template v-else>
                                  <a
                                    :title="data.product_name"
                                    :href="getGoLink(data.go_link, data.slug)"
                                    class="bonus-link custom-font-1 cas-link"
                                    target="_blank"
                                    :rel="
                                      $root.change_cta_to_sponsored
                                        ? 'nofollow sponsored'
                                        : 'nofollow'
                                    "
                                    :style="{
                                      '--color-hover':
                                        $root.color_schema.primary_btn,
                                    }"
                                  >
                                    <span
                                      v-if="
                                        data.bonus_match &&
                                        data.exclusive_bonus_amount &&
                                        data.exclusive_bonus_match
                                      "
                                      >{{ data.exclusive_bonus_match }}%
                                      {{ $root.i18n.match_bonus_up_to }}
                                      {{
                                        data.exclusive_bonus_amount
                                          | currency(data.bonus_currency)
                                      }}</span
                                    >
                                    <span
                                      v-if="
                                        data.bonus_match &&
                                        !data.exclusive_bonus_amount &&
                                        data.bonus_amount
                                      "
                                      >{{ data.bonus_match }}%
                                      {{ $root.i18n.match_bonus_up_to }}
                                      {{
                                        data.bonus_amount
                                          | currency(data.bonus_currency)
                                      }}</span
                                    >
                                    <span
                                      v-if="data.freespin || data.freebie_name"
                                    >
                                      <template
                                        v-if="
                                          (data.exclusive_bonus_amount ||
                                            data.bonus_amount) &&
                                          data.bonus_match
                                        "
                                        >+</template
                                      >
                                      <template
                                        v-if="
                                          data.show_freebie_currency === '1'
                                        "
                                        >{{
                                          data.freespin
                                            | currency(data.bonus_currency)
                                        }}</template
                                      >
                                      <template v-else>{{
                                        data.freespin
                                      }}</template>
                                      {{ data.freebie_name }}
                                    </span>
                                  </a>
                                </template>
                              </span>
                              <div class="row mar-2">
                                <StarRating
                                  :rating="
                                    parseFloat((data.rating / 2).toFixed(1))
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <a
                            :title="data.product_name"
                            :href="getGoLink(data.go_link, data.slug)"
                            :class="{
                              'cta cta-primary cta-promotion cta-block custom-btn hover-btn cas-link': true,
                              'text-white':
                                !$root.override_ctabtntxt_color &&
                                !getContrastYIQ($root.color_schema.primary_btn),
                              'text-gray':
                                !$root.override_ctabtntxt_color &&
                                getContrastYIQ($root.color_schema.primary_btn),
                              'text-cta-override':
                                $root.override_ctabtntxt_color,
                            }"
                            target="_blank"
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                              '--primary-btn-hover': pSBC(
                                -0.2,
                                $root.color_schema.primary_btn
                              ),
                            }"
                          >
                            <span class="cta-text"
                              ><img
                                :src="crownIcon"
                                height="16"
                                width="24"
                                alt="Crown"
                                v-if="index === 0"
                              />{{ data.cta_button_text }}</span
                            ><span
                              class="hover-text"
                              v-for="(char, indexGo) in $root.i18n.go_to_casino"
                              :key="indexGo + `dfpp`"
                              >{{ char }}</span
                            >
                          </a>
                          <template v-if="$root.enable_piwik_reload">
                            <a
                              :title="data.product_name"
                              v-if="data.review_link"
                              :href="getRouteLink(data.review_link, 'review')"
                              class="read-review"
                              >{{
                                getPartnerGlobalString(
                                  $root.i18n.partner_name_review,
                                  data.product_name
                                )
                              }}</a
                            >
                            <span class="emt-sp" v-else>&nbsp;</span>
                          </template>
                          <template v-else>
                            <router-link
                              :title="data.product_name"
                              v-if="data.review_link"
                              :to="getRouteLink(data.review_link, 'review')"
                              class="read-review"
                              >{{
                                getPartnerGlobalString(
                                  $root.i18n.partner_name_review,
                                  data.product_name
                                )
                              }}</router-link
                            >
                            <span class="emt-sp" v-else>&nbsp;</span>
                          </template>
                        </div>
                        <div
                          :class="{
                            'cas-terms terms-404': true,
                            'terms-top-choice':
                              index === 0 &&
                              ((data.bonus_tc && data.bonus_tc != '') ||
                                (data.terms && data.terms != '')),
                          }"
                          v-if="
                            (data.bonus_tc && data.bonus_tc != '') ||
                            (data.terms && data.terms != '')
                          "
                        >
                          <span
                            class="cas-term"
                            style="text-align: center"
                            v-if="data.bonus_tc && data.bonus_tc != ''"
                            v-html="data.bonus_tc.trim()"
                            :style="{
                              '--primary-btn': $root.color_schema.primary_btn,
                            }"
                          ></span>
                          <span
                            class="card-stroke"
                            v-if="
                              data.bonus_tc &&
                              data.terms &&
                              data.bonus_tc != '' &&
                              data.terms != ''
                            "
                            >|</span
                          >
                          <a
                            :rel="
                              $root.change_cta_to_sponsored
                                ? 'nofollow sponsored'
                                : 'nofollow'
                            "
                            class="cas-term"
                            v-if="data.terms && data.terms != ''"
                            :title="data.product_name"
                            :href="getGoLink(data.term_link, data.slug)"
                            target="_blank"
                            >{{ data.terms }}</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <div class="text-center pt-10 span-no-text" v-else>
                {{ $root.i18n.no_toplist_available_intime }}
              </div>
            </div>
          </template>
          <template v-else>
            <CustomComponent :key="`${data.blockName}-${index}`" 
                :blockData="data" 
                :recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
                :bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
                :blockIndex="index"
                pageValue="404"
                :scheme="getContrastYIQ($root.color_schema.primary) ? 'light' : 'dark'"
                />
          </template>
        </template>
      </div>
    </div>
  </main>
</template>

<script>
import CustomComponent from '@/components/CustomComponent';
import StarRating from "@/components/ui/StarRating";

import { HttpService } from "@/api/Pages.api";
import currency from "@/misc/currency";
import {
  pSBC,
  getContrastYIQ,
} from "@/misc/misc-function";

export default {
  name: "NotFound",
  data() {
    return {
      page404Data: "",
      page404DataBlocks: [],
      gamesTop3: [],
      gamesTop3Title: [],
      assets_images: {
        type: Object,
        default: () => {},
      },
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      hideBonusLabelGB: false,
      hideToplistLabelGB: false,
      bluebar: {},
      crownIcon: '',
    };
  },
  components: {
    CustomComponent,
    StarRating
  },
  created: function () {
    const assetPath = `${global.wpvue_script_data_params.site_url}/wp-content/themes/wpvue/src/assets/images`
    this.crownIcon = global.wpvue_script_data_params.data.site_data.theme_icons.crown || assetPath + '/svg-icons/crown.svg';
  },
  mounted: function () {
    this.$root.show_footer = true;
    HttpService.get404Body(
      this.$root.wp_country && this.$root.wp_country != ""
        ? this.$root.wp_country
        : this.$cookies.get("wp-country"),
      this.$root.wp_state && this.$root.wp_state != ""
        ? this.$root.wp_state
        : this.$cookies.get("wp-state"),
      this.$root.page404_id,
      this.$root.user_id
    )
      .then((res) => {
        this.page404Data = res.data.data;
        this.page404DataBlocks = res.data.data.content.blocks;

        // GameTop3
        this.gamesTop3 = [];
        this.page404DataBlocks.forEach((ele) => {
          if (
            ele.blockName === "wpvcb/casino-toplist" &&
            ele.attrs &&
            ele.attrs.style === "gamepage_top_3"
          ) {
            this.gamesTop3.push(ele.filtered_content);
            this.gamesTop3Title.push(
              ele.attrs.block_title ? ele.attrs.block_title : ""
            );
          }
        });

        // Assets Sizes
        this.assets_images =
          Object.keys(this.$root.asset_sizes).length > 0
            ? this.$root.asset_sizes
            : "";
        //console.log(this.gamesTop3);
        if (this.gamesTop3.length > 0)
          this.getBonusShowHideGB(this.gamesTop3[0][0]);

        this.$nextTick(() => {
          this.updateBonusHeight();
        });
        window.addEventListener("resize", () => {
          this.updateBonusHeight();
          let windowWidth = window.innerWidth;
          if (!this.smallCardView && windowWidth >= 768) {
            this.smallCardView = true;
          }
        });
        this.$root.body_loading_status = true;
      })
      .catch((err) => console.log(err));
  },
  methods: {
    pSBC,
    getContrastYIQ,
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
    updateBonusHeight: function () {
      let heightArr = [];
      document.querySelectorAll(".gamefree-casino-404").forEach((ele) => {
        heightArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".gamefree-casino-404").forEach((ele) => {
        ele.style.height = `${Math.max(...heightArr)}px`;
      });

      let heightTermsArr = [];
      document.querySelectorAll(".terms-404").forEach((ele) => {
        heightTermsArr.push(ele.clientHeight);
      });
      document.querySelectorAll(".terms-404").forEach((ele) => {
        ele.style.height = `${Math.max(...heightTermsArr)}px`;
      });
    },
    getBonusShowHideGB: function (partner) {
      let hideBonus = this.getCASToplistShowHideData(partner);
      if (hideBonus.hide_bonus === "1") {
        this.hideBonusLabelGB = true;
      } else if (hideBonus.hide_toplist === "1") {
        this.hideToplistLabelGB = true;
      }
    },
  },
  filters: {
    currency,
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.page-not-found {
  display: block;
  min-height: 100%;
  position: relative;
  overflow: hidden;
  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: -422px;
    height: 100%;
    width: 838px;
    background: rgba(241, 242, 242, 0.1);
    transform: skewX(-31deg);
    -ms-transform: skewX(-31deg);
    opacity: 0;
    @media (min-width: @sizes[tablet]) {
      opacity: 1;
    }
  }
}

.error-wrapper {
  display: flex;
  flex-wrap: wrap-reverse;
  justify-content: space-between;
  .error-text {
    width: 100%;
    padding-top: 45px;
    text-align: center;
    .span-header {
      display: block;
      font-weight: 900;
      font-size: 40px;
      line-height: 49px;
      color: inherit;
      @media (min-width: @sizes[small]) {
        font-size: 120px;
        line-height: 146px;
      }
    }
    .span-paragraph {
      display: block;
      font-weight: normal;
      font-size: 14px;
      line-height: 119.97%;
      color: inherit;
      @media (min-width: @sizes[small]) {
        font-size: 24px;
      }
    }
    .button-wrap {
      margin-top: 32px;
      .back-button {
        width: 80%;
        font-weight: bold;
        font-size: 14px;
        line-height: 152%;
        border: 3px solid;
        box-sizing: border-box;
        border-radius: 100px;
        height: 58px;
        color: inherit;
        padding: 16px;
        display: inline-block;
        text-align: center;
        @media (min-width: @sizes[small]) {
          font-size: 18px;
          line-height: 22px;
        }
        @media (min-width: @sizes[tablet]) {
          width: 372px;
        }
      }
    }
    @media (min-width: @sizes[tablet]) {
      width: 50%;
      text-align: left;
    }
  }
  .error-img {
    padding-top: 42px;
    width: 100%;
    text-align: center;
    img {
      width: 180px;
      @media (min-width: @sizes[small]) {
        width: 438px;
      }
    }
    @media (min-width: @sizes[tablet]) {
      width: 438px;
    }
  }
  @media (min-width: @sizes[tablet]) {
    flex-wrap: wrap;
    padding: 0;
  }
}

.content-wrapper {
  padding-top: 25px;
}

.mar-2 {
  margin-left: 2px;
}

.play-card {
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  .border-radius(12px);
  background: @white;
  padding: 10px 15px 13px;
  border: 2px solid transparent;
  min-width: 280px;
  @media (min-width: @sizes[md-large]) {
    padding: 15px;
  }
  &.top-choice {
    border-color: @yellow;
  }
  &-top {
    .display-flex();
    .align-items(start);
    &-img {
      min-width: 68px;
      max-width: 68px;
      height: 68px;
      @media (min-width: @sizes[large]) {
        min-width: 72px;
        max-width: 72px;
        height: 72px;
      }
      img {
        width: 100%;
        height: 100%;
        .border-radius(8px);
        object-fit: cover;
      }
    }
    &-right {
      padding: 0 8px;
      white-space: normal;
      min-height: 100px;
      @media (min-width: @sizes[md-large]) {
        padding: 0 16px;
      }
      h5 {
        margin: 0px 0 5px 0;
        color: @lightdark;
      }
      .rating-wrapper {
        .align-items(center);
        .justify-content-flex-start();
      }
    }
  }
  .cta {
    margin-top: 0;
    padding: 17px 18px;
    font-size: 18px;
    line-height: 100%;
    @media (min-width: @sizes[md-large]) {
      padding: 17px 18px;
      font-size: 18px;
      line-height: 100%;
    }
    &:hover {
      background: @darkred;
      border-color: @darkred;
      color: @white;
      box-shadow: none;
      -webkit-box-shadow: none;
    }
  }
  .read-review {
    display: block;
    white-space: break-spaces;
    font-weight: normal;
    font-size: 14px;
    line-height: 150%;
    color: #9b9b9b !important;
    margin: 0 auto;
    text-decoration: underline;
    width: 240px;
    margin-top: 10px;
    text-align: center;
    @media (min-width: @sizes[sm-large]) {
      width: 350px;
    }
  }
}

.stripe {
  position: absolute;
  left: 0;
  width: 100%;
  height: 18px;
  bottom: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffd039;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  &-text {
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 600;
    font-size: 10px;
    line-height: 100%;
  }
  img {
    width: 18px !important;
    height: 14px !important;
    margin: 3px auto;
    object-fit: contain !important;
  }
  @media (max-width: @sizes[small]) {
    position: relative;
    top: -17px;
  }
}

.mw-300 {
  min-width: 300px;
  @media (min-width: @sizes[large]) {
    min-width: auto;
  }
}

.mobile-container {
  padding-bottom: 25px;
  .span-h1 {
    color: var(--primary-color);
  }
}

.terms_tc {
  text-decoration: underline;
  color: @darkblue;
  font-size: 12px;
}

.span-h5 {
  line-height: 21px !important;
  margin: 0 !important;
}

.term-recas {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.cas-terms {
  background: #dfe1e3;
  display: flex;
  padding: 5px 15px;
  margin: 0;
  width: 100%;
  font-weight: 400;
  color: @lightdark;
  min-height: 33px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  line-height: 15px;
  font-size: 0.75rem;
  white-space: pre-wrap;
  min-width: 254px;
  align-items: center;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.25);
  span {
    margin: auto 0;
  }
  @media (min-width: @sizes[medium]) {
    line-height: 18px;
    font-size: 0.75rem;
  }
  a {
    cursor: pointer;
    text-decoration: underline !important;
    &:hover {
      color: var(--primary-btn);
    }
  }
}

.rm-bottom-color {
  border-bottom-color: transparent !important;
}

.terms-top-choice {
  border: 2px solid #ffd039;
  border-top-color: transparent;
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.25);
}

.cut-span {
  color: inherit;
}

.emt-sp {
  display: block;
  margin-top: 6px;
}

.pos-relative {
  position: relative;
}
</style>


// WEBPACK FOOTER //
// src/pages/404.vue